import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { CourseRelevantExecution } from '../models/course-relevant-execution.model';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';

export class SetCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] SetCourseRelevantExecution';

    constructor(public payload: CourseRelevantExecution) {}
}

export class UnsetCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] UnsetCourseRelevantExecution';
}

export class CreateCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] CreateCourseRelevantExecution';

    constructor(public payload: CourseRelevantExecution) {}
}

export class CreateCourseRelevantExecutionSuccess {
    static readonly type = '[CourseRelevantExecution] CreateCourseRelevantExecutionSuccess';

    constructor(public payload: CourseRelevantExecution) {}
}

export class CreateCourseRelevantExecutionFailure {
    static readonly type = '[CourseRelevantExecution] CreateCourseRelevantExecutionFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class FetchCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] FetchCourseRelevantExecution';

    constructor(public payload: string) {}
}

export class FetchCourseRelevantExecutionSuccess {
    static readonly type = '[CourseRelevantExecution] FetchCourseRelevantExecutionSuccess';

    constructor(public payload: CourseRelevantExecution) {}
}

export class FetchCourseRelevantExecutionFailure {
    static readonly type = '[CourseRelevantExecution] FetchCourseRelevantExecutionFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class UpdateCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] UpdateCourseRelevantExecution';

    constructor(
        public payload: {
            programExecutionId: string;
            courseOfferingId: string;
            isDefault: boolean;
        }
    ) {}
}

export class UpdateCourseRelevantExecutionSuccess {
    static readonly type = '[CourseRelevantExecution] UpdateCourseRelevantExecutionSuccess';

    constructor(public payload: CourseRelevantExecution) {}
}

export class UpdateCourseRelevantExecutionFailure {
    static readonly type = '[CourseRelevantExecution] UpdateCourseRelevantExecutionFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class CreateCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] CreateCourseRelevantExecutions';

    constructor(
        public payload: {
            programExecutionId: string;
            courseOfferingId: string;
            courseExecutionIds: string[];
        }
    ) {}
}

export class CreateCourseRelevantExecutionsSuccess {
    static readonly type = '[CourseRelevantExecution] CreateCourseRelevantExecutionsSuccess';

    constructor() {}
}

export class CreateCourseRelevantExecutionsFailure {
    static readonly type = '[CourseRelevantExecution] CreateCourseRelevantExecutionsFailure';

    constructor() {}
}

export class DeleteCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] DeleteCourseRelevantExecution';

    constructor(
        public payload: {
            programExecutionId: string;
            courseOfferingId: string;
            courseExecutionIds: string[];
        }
    ) {}
}

export class DeleteCourseRelevantExecutionSuccess {
    static readonly type = '[CourseRelevantExecution] DeleteCourseRelevantExecutionSuccess';

    constructor() {}
}

export class DeleteCourseRelevantExecutionFailure {
    static readonly type = '[CourseRelevantExecution] DeleteCourseRelevantExecutionFailure';

    constructor() {}
}

export class SetCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] SetCourseRelevantExecutions';

    constructor(public payload: CourseRelevantExecution[]) {}
}

export class FetchCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] FetchCourseRelevantExecutions';

    constructor(
        public payload: {
            programExecutionId: string;
            courseOfferingId: string;
            search?: string;
            context?: string;
        }
    ) {}
}

export class FetchCourseRelevantExecutionsSuccess {
    static readonly type = '[CourseRelevantExecution] FetchCourseRelevantExecutionsSuccess';
}

export class FetchCourseRelevantExecutionsFailure {
    static readonly type = '[CourseRelevantExecution] FetchCourseRelevantExecutionsFailure';
}

export class ToggleSelectedCourseRelevantExecution {
    static readonly type = '[CourseRelevantExecution] ToggleSelectedCourseRelevantExecution';

    constructor(public payload: string) {}
}

export class SelectFilteredCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] SelectFilteredCourseRelevantExecutions';
}

export class DeselectSelectedCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] DeselectSelectedCourseRelevantExecutions';
}

export class SearchCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] SearchCourseRelevantExecutions';

    constructor(public payload: string) {}
}
